import { Component, DOCUMENT, inject } from '@angular/core';
import { ButtonComponent } from 'src/app/shared/ui/button/button.component';

/**
 * The full-page error the root component shows instead of the app when the startup data (the enum catalogue) failed
 * to load; its button reloads the page, which runs the startup load again.
 */
@Component({
	selector: 'app-startup-error',
	templateUrl: './startup-error.component.html',
	imports: [ButtonComponent],
	host: { class: 'flex flex-1 flex-col' },
})
export class StartupErrorComponent {
	private readonly document = inject(DOCUMENT);

	protected reload(): void {
		this.document.location.reload();
	}
}
